import React from 'react';

import MedicationLiquidIcon from '@mui/icons-material/MedicationLiquid';
import {
  Button,
} from '@mui/material';

import AddDrug from '../../../HealthRecord/HealthRecordCategory/Drug/AddDrug';

import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';
import type { UserType } from '@/types/domain/user/redux';

/** 入力 */
export type LineButtonsInput = {
  /** 日付 */
  date: Date,
  /** ユーザー */
  user: UserType,
  /** 子ども */
  child: ChildJson,
  /** 施設リスト */
  facilityList: FacilityJson[],
};

const MedicationButton: React.FC<LineButtonsInput> = ({
  date,
  user,
  child,
  facilityList,
}) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<MedicationLiquidIcon />}
        style={{ marginLeft: 'auto' }}
        onClick={() => setIsOpen(true)}
      >
        薬
      </Button>
      <AddDrug
        isOpen={isOpen}
        close={() => setIsOpen(false)}
        child={child}
        user={user}
        facilityList={facilityList}
        date={date}
      />
    </>
  );
};

export default MedicationButton;
